import React from "react";
import { Question as QuestionType } from "../../../../Interface/Index";
import { message } from "antd";

interface QuestionProps {
  currentQuestion: QuestionType | undefined;
  containerRef: React.RefObject<HTMLDivElement> | null;
}

const Question: React.FC<QuestionProps> = ({
  currentQuestion,
  containerRef,
}) => {
  message.config({
    getContainer: () =>
      containerRef && containerRef.current ? containerRef.current : document.body,
  });
  
  const handleCopy = (e: React.ClipboardEvent<HTMLParagraphElement>) => {
    e.preventDefault();
    message.warning("Copying is disabled.");
  };

  return (
    <div
      className="question-text"
      style={
        currentQuestion && currentQuestion.type === "coding"
          ? { textAlign: "center", padding: "0px 20px" }
          : {}
      }
    >
      <p onCopy={handleCopy}>{currentQuestion?.description}</p>
    </div>
  );
};

export default Question;
